var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgPayment(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B0A8F0",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20.674a10.539 10.539 0 01-1.919 6.07 10.006 10.006 0 01-5.012 3.74 9.686 9.686 0 01-6.184-.026 10.014 10.014 0 01-4.984-3.78 10.544 10.544 0 01-1.872-6.085c.015-2.182.7-4.303 1.956-6.058a10.001 10.001 0 015.036-3.706 9.687 9.687 0 016.183.066 10.03 10.03 0 014.92 3.761A10.557 10.557 0 0130 20.674z",
    fill: "#5AB35A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.363c-.01 2.18-.69 4.301-1.94 6.058a10.003 10.003 0 01-5.022 3.718 9.686 9.686 0 01-6.178-.044 10.016 10.016 0 01-4.97-3.79 10.545 10.545 0 01-1.86-6.084c.018-2.18.705-4.298 1.962-6.05a10 10 0 015.034-3.698 9.686 9.686 0 016.178.067 10.032 10.032 0 014.933 3.78A10.559 10.559 0 0130 19.363z",
    fill: "#6DD96D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.204 9.54l-8.788 18.351c-1.95-1.426-3.344-3.524-3.93-5.917a10.67 10.67 0 01.734-7.135c1.06-2.212 2.848-3.96 5.045-4.932a9.74 9.74 0 016.94-.367z",
    fill: "#85F285"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.068 15.936h5.555a2.824 2.824 0 00-.2-1.055 2.754 2.754 0 00-.578-.894 2.657 2.657 0 00-.866-.597 2.587 2.587 0 00-1.022-.208h-.624v-.614a1.4 1.4 0 00-.387-.942 1.314 1.314 0 00-.91-.405c-.354 0-.693.145-.943.403a1.4 1.4 0 00-.39.974v.636a3.609 3.609 0 00-2.33 1.202 3.836 3.836 0 00-.96 2.5 3.834 3.834 0 001.108 2.634 3.595 3.595 0 002.583 1.067h2a.8.8 0 01.632.218.85.85 0 01.269.63.876.876 0 01-.27.629.819.819 0 01-.631.218h-5.728c0 .73.281 1.43.781 1.947.5.516 1.179.806 1.886.806h.623v.615a1.415 1.415 0 00.401.992c.128.129.28.23.446.297.166.068.344.1.523.095.353 0 .692-.145.942-.403a1.4 1.4 0 00.391-.974v-.644a3.435 3.435 0 002.414-1.161 3.664 3.664 0 00.912-2.584 3.643 3.643 0 00-1.125-2.493 3.416 3.416 0 00-2.502-.942h-2a.971.971 0 01-.708-.27 1.036 1.036 0 01-.317-.707c.013-.268.128-.52.32-.702a.97.97 0 01.705-.268z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(10 9)",
    d: "M0 0h20v22H0z"
  })))));
}
export default SvgPayment;